import withRouter from 'react-router/lib/withRouter';
import compose from 'recompose/compose';
import ServiceItem from '../components/ServiceItem';

export default compose(
  withRouter,
)(ServiceItem);
